/* eslint-disable react/prop-types */
import React, { createContext, useContext, useEffect, useState, useMemo } from "react";

const dictionary = {
    es: {
        nav: {
            services: "Servicios",
            value: "Por qué Nida",
            cases: "Casos",
            process: "Proceso",
            trust: "Confianza",
            contact: "Contacto",
            cta: "Asesoría gratuita",
            admin: "Admin",
        },
        hero: {
            eyebrow: "Partner tecnológico integral",
            title1: "Soluciones",
            title2: "Digitales 360",
            title3: "para empresas que quieren crecer",
            subtitle:
                "Desarrollo, IT, ciberseguridad, inteligencia artificial y transformación digital en un solo proveedor.",
            cta1: "Solicitar asesoría gratuita",
            cta2: "Ver servicios",
            badge1: "ISO 27001 · ENS · NIS2",
            badge2: "+15 años en el grupo Laredo Agenjo",
        },
        services: {
            eyebrow: "Servicios 360",
            title: "Un solo partner.\nTodo el ecosistema digital.",
            subtitle:
                "Agrupamos las disciplinas que tu empresa necesita en un único equipo de especialistas. Sin proveedores fragmentados.",
            cta: "Saber más",
            cats: [
                {
                    key: "dev",
                    title: "Desarrollo Digital",
                    desc: "Webs, apps a medida y plataformas e-commerce escalables.",
                    items: ["Páginas web", "Aplicaciones a medida", "E-commerce"],
                },
                {
                    key: "it",
                    title: "IT & Infraestructura",
                    desc: "La columna vertebral tecnológica de tu negocio, sin interrupciones.",
                    items: ["Redes", "Cloud", "Soporte técnico", "Renting de equipos"],
                },
                {
                    key: "sec",
                    title: "Ciberseguridad & Compliance",
                    desc: "Cumplimiento normativo y protección avanzada frente a amenazas reales.",
                    items: ["NIS2 · ENS · ISO 27001 · RGPD", "Auditorías", "Protección avanzada"],
                },
                {
                    key: "ai",
                    title: "Inteligencia Artificial",
                    desc: "Automatización e IA aplicada para escalar procesos y decisiones.",
                    items: ["Automatización", "IA para negocio", "Integraciones"],
                },
                {
                    key: "mkt",
                    title: "Marketing & Branding",
                    desc: "Identidad, contenido y estrategia digital para crecer con foco.",
                    items: ["Identidad corporativa", "Redes sociales", "Estrategia digital", "Merchandising"],
                },
                {
                    key: "iot",
                    title: "Domótica & Espacios Inteligentes",
                    desc: "Hogar y oficina automatizados con instalación y mantenimiento.",
                    items: ["Hogar y oficina", "Instalación y mantenimiento"],
                },
                {
                    key: "doc",
                    title: "Gestión Documental",
                    desc: "Del papel a la nube con trazabilidad completa.",
                    items: ["Digitalización", "Almacenamiento físico y cloud", "Destrucción segura"],
                },
            ],
        },
        value: {
            eyebrow: "Por qué Nida Digital",
            title: "Cinco razones para\nelegir un partner integral.",
            pillars: [
                { title: "Servicio integral 360", desc: "Estrategia, ejecución y mantenimiento bajo el mismo techo." },
                { title: "Un solo proveedor", desc: "Menos coordinación, más responsabilidad y resultados." },
                { title: "Soporte continuo", desc: "Equipo accesible y SLAs reales para tu operativa diaria." },
                { title: "Adaptación normativa", desc: "NIS2, ENS, ISO 27001 y RGPD aplicados a tu día a día." },
                { title: "Tecnología avanzada accesible", desc: "Cloud, IA y ciber al alcance de empresas reales." },
            ],
        },
        cases: {
            eyebrow: "Casos de uso",
            title: "Lo que resolvemos\npor ti.",
            items: [
                {
                    title: "Digitalizamos tu empresa desde cero",
                    desc: "Diseñamos un plan de transformación end-to-end: web, ERP, procesos y formación de equipos.",
                    bullets: ["Auditoría inicial", "Roadmap por fases", "Formación interna"],
                },
                {
                    title: "Modernizamos tu infraestructura IT",
                    desc: "Migramos a cloud, securizamos redes y dejamos tu operativa lista para escalar.",
                    bullets: ["Cloud & redes", "Renting de equipos", "Soporte 24/7"],
                },
                {
                    title: "Protegemos tu negocio ante ciberataques",
                    desc: "Detección, respuesta y compliance NIS2/ENS/ISO 27001 con monitorización continua.",
                    bullets: ["Auditorías", "Hardening", "Plan de respuesta"],
                },
                {
                    title: "Automatizamos procesos con IA",
                    desc: "Identificamos cuellos de botella y los automatizamos con IA y herramientas integradas.",
                    bullets: ["Mapeo de procesos", "Pilotos rápidos", "Integraciones a medida"],
                },
            ],
        },
        process: {
            eyebrow: "Proceso",
            title: "Cómo trabajamos contigo",
            steps: [
                { n: "01", title: "Análisis", desc: "Entendemos tu operación, riesgos y objetivos en profundidad." },
                { n: "02", title: "Planificación", desc: "Diseñamos un roadmap claro con hitos y métricas accionables." },
                { n: "03", title: "Implementación", desc: "Ejecutamos con un equipo único y comunicación cercana." },
                { n: "04", title: "Mantenimiento", desc: "Soporte y mejora continua para que nada se detenga." },
            ],
        },
        trust: {
            eyebrow: "Confianza",
            title: "Cumplimiento, certificaciones y clientes.",
            certs: ["NIS2", "ISO 27001", "ENS", "RGPD", "ISO 9001", "ENISA"],
            testimonialsTitle: "Lo que dicen las empresas con las que trabajamos",
        },
        finalCta: {
            eyebrow: "Da el siguiente paso",
            title: "Impulsa tu negocio con tecnología.",
            subtitle: "Cuéntanos tu reto y te respondemos con un plan en 48 horas.",
        },
        contact: {
            title: "Habla con nosotros",
            subtitle: "Te respondemos en menos de 48 horas laborables.",
            name: "Nombre",
            email: "Email corporativo",
            phone: "Teléfono",
            company: "Empresa",
            service: "Servicio de interés",
            servicePlaceholder: "Selecciona una categoría",
            message: "Cuéntanos tu reto",
            send: "Enviar mensaje",
            sending: "Enviando…",
            success: "¡Gracias! Hemos recibido tu mensaje.",
            error: "No hemos podido enviar tu mensaje. Inténtalo de nuevo.",
            consent: "Acepto la política de privacidad",
        },
        footer: {
            tagline: "Partner tecnológico integral del grupo Laredo Agenjo.",
            services: "Servicios",
            company: "Compañía",
            legal: "Legal",
            contact: "Contacto",
            copyright: "© {year} Nida Digital · Anpada XXI · Grupo Laredo Agenjo. Todos los derechos reservados.",
            links: {
                privacy: "Privacidad",
                terms: "Términos",
                cookies: "Cookies",
                about: "Sobre nosotros",
                careers: "Trabaja con nosotros",
                blog: "Blog",
            },
        },
        admin: {
            login: "Acceder al panel",
            password: "Contraseña",
            signIn: "Entrar",
            wrong: "Contraseña incorrecta",
            title: "Panel CRM · Leads",
            subtitle: "Gestiona los contactos recibidos desde la web",
            logout: "Cerrar sesión",
            empty: "Aún no hay leads. ¡Comparte la web!",
            statuses: { new: "Nuevo", contacted: "Contactado", qualified: "Cualificado", won: "Ganado", lost: "Perdido" },
        },
    },
    en: {
        nav: {
            services: "Services",
            value: "Why Nida",
            cases: "Use cases",
            process: "Process",
            trust: "Trust",
            contact: "Contact",
            cta: "Free consultation",
            admin: "Admin",
        },
        hero: {
            eyebrow: "End-to-end technology partner",
            title1: "360° Digital",
            title2: "Solutions",
            title3: "for companies that want to grow",
            subtitle:
                "Development, IT, cybersecurity, AI and digital transformation under a single provider.",
            cta1: "Request a free consultation",
            cta2: "Explore services",
            badge1: "ISO 27001 · ENS · NIS2",
            badge2: "+15 years in the Laredo Agenjo group",
        },
        services: {
            eyebrow: "360° Services",
            title: "One partner.\nThe whole digital stack.",
            subtitle:
                "We bring together every discipline your company needs into a single specialist team. No fragmented vendors.",
            cta: "Learn more",
            cats: [
                { key: "dev", title: "Digital Development", desc: "Websites, custom apps and scalable e-commerce.", items: ["Websites", "Custom apps", "E-commerce"] },
                { key: "it", title: "IT & Infrastructure", desc: "The technological backbone of your business, with zero downtime.", items: ["Networks", "Cloud", "Tech support", "Equipment leasing"] },
                { key: "sec", title: "Cybersecurity & Compliance", desc: "Regulatory compliance and advanced protection against real threats.", items: ["NIS2 · ENS · ISO 27001 · GDPR", "Audits", "Advanced protection"] },
                { key: "ai", title: "Artificial Intelligence", desc: "Automation and applied AI to scale processes and decisions.", items: ["Automation", "AI for business", "Integrations"] },
                { key: "mkt", title: "Marketing & Branding", desc: "Identity, content and digital strategy to grow with focus.", items: ["Corporate identity", "Social media", "Digital strategy", "Merchandising"] },
                { key: "iot", title: "Smart Spaces & IoT", desc: "Automated home and office with installation and maintenance.", items: ["Home and office", "Install & maintenance"] },
                { key: "doc", title: "Document Management", desc: "From paper to cloud with full traceability.", items: ["Digitization", "Physical & cloud storage", "Secure destruction"] },
            ],
        },
        value: {
            eyebrow: "Why Nida Digital",
            title: "Five reasons to choose\nan integral partner.",
            pillars: [
                { title: "Full 360° service", desc: "Strategy, execution and maintenance under one roof." },
                { title: "Single provider", desc: "Less coordination, more accountability and results." },
                { title: "Continuous support", desc: "Accessible team and real SLAs for your daily operations." },
                { title: "Regulatory alignment", desc: "NIS2, ENS, ISO 27001 and GDPR applied day to day." },
                { title: "Accessible advanced tech", desc: "Cloud, AI and cyber within reach of real companies." },
            ],
        },
        cases: {
            eyebrow: "Use cases",
            title: "What we solve\nfor you.",
            items: [
                { title: "We digitize your company from scratch", desc: "End-to-end transformation plan: web, ERP, processes and team training.", bullets: ["Initial audit", "Phased roadmap", "Team training"] },
                { title: "We modernize your IT infrastructure", desc: "We migrate to cloud, secure networks and prepare your operations to scale.", bullets: ["Cloud & networks", "Equipment leasing", "24/7 support"] },
                { title: "We protect your business from cyberattacks", desc: "Detection, response and NIS2/ENS/ISO 27001 compliance with continuous monitoring.", bullets: ["Audits", "Hardening", "Response plan"] },
                { title: "We automate processes with AI", desc: "We identify bottlenecks and automate them with AI and integrated tools.", bullets: ["Process mapping", "Quick pilots", "Custom integrations"] },
            ],
        },
        process: {
            eyebrow: "Process",
            title: "How we work with you",
            steps: [
                { n: "01", title: "Analysis", desc: "We understand your operation, risks and goals in depth." },
                { n: "02", title: "Planning", desc: "We design a clear roadmap with milestones and metrics." },
                { n: "03", title: "Implementation", desc: "We execute with a single team and close communication." },
                { n: "04", title: "Maintenance", desc: "Support and continuous improvement so nothing stops." },
            ],
        },
        trust: {
            eyebrow: "Trust",
            title: "Compliance, certifications and clients.",
            certs: ["NIS2", "ISO 27001", "ENS", "GDPR", "ISO 9001", "ENISA"],
            testimonialsTitle: "What our clients say",
        },
        finalCta: {
            eyebrow: "Take the next step",
            title: "Power your business with technology.",
            subtitle: "Tell us your challenge and we'll come back with a plan in 48 hours.",
        },
        contact: {
            title: "Talk to us",
            subtitle: "We reply within 48 business hours.",
            name: "Name",
            email: "Work email",
            phone: "Phone",
            company: "Company",
            service: "Service of interest",
            servicePlaceholder: "Pick a category",
            message: "Tell us about your challenge",
            send: "Send message",
            sending: "Sending…",
            success: "Thanks! We've received your message.",
            error: "We couldn't send your message. Please try again.",
            consent: "I accept the privacy policy",
        },
        footer: {
            tagline: "End-to-end technology partner from the Laredo Agenjo group.",
            services: "Services",
            company: "Company",
            legal: "Legal",
            contact: "Contact",
            copyright: "© {year} Nida Digital · Anpada XXI · Laredo Agenjo Group. All rights reserved.",
            links: { privacy: "Privacy", terms: "Terms", cookies: "Cookies", about: "About", careers: "Careers", blog: "Blog" },
        },
        admin: {
            login: "Sign in to dashboard",
            password: "Password",
            signIn: "Sign in",
            wrong: "Wrong password",
            title: "CRM · Leads",
            subtitle: "Manage contacts received from the website",
            logout: "Sign out",
            empty: "No leads yet. Share the website!",
            statuses: { new: "New", contacted: "Contacted", qualified: "Qualified", won: "Won", lost: "Lost" },
        },
    },
};

const I18nContext = createContext({ lang: "es", setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("nida_lang") || "es");

    useEffect(() => {
        localStorage.setItem("nida_lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const value = useMemo(() => {
        const get = (path) => {
            const parts = path.split(".");
            let cur = dictionary[lang];
            for (const p of parts) {
                cur = cur?.[p];
                if (cur === undefined) return path;
            }
            return cur;
        };
        return { lang, setLang, t: get, dict: dictionary[lang] };
    }, [lang]);

    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
